import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const discussionApiService = createApi({
  reducerPath: "discussionApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createDiscussion: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `discussion/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getDiscussionByCourseId: builder.query({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `discussion/course/${id}${query}`,
          method: "GET",
        };
      },
    }),
    updateDiscussion: builder.mutation({
      query: ({ id, body, params }) => {
        let query = queryParams(params);
        return {
          url: `discussion/${id}${query}`,
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useCreateDiscussionMutation,
  useGetDiscussionByCourseIdQuery,
  useUpdateDiscussionMutation,
} = discussionApiService;
